import { OnChangePlugin } from "@lexical/react/LexicalOnChangePlugin";
import { type ReactElement } from "react";

import { useLexicalPlainTextSync } from "../../compose/useLexicalPlainTextSync";

export interface ValueSyncPluginProps {
  value: string;
  onChange: (next: string) => void;
}

export function ValueSyncPlugin({
  value,
  onChange,
}: ValueSyncPluginProps): ReactElement {
  const handleChange = useLexicalPlainTextSync({
    value,
    onChange,
    controlled: true,
  });

  return <OnChangePlugin onChange={handleChange} ignoreSelectionChange />;
}
